export const CacheSelectWuyouOrderInfoKey = 'CacheSelectWuyouOrderInfoKey'
export const CacheSelectRepairOrderInfoKey = 'CacheSelectRepairOrderInfoKey'
export const CachePinanOrderPayed = 'CachePinanOrderPayed'
export const isUseIframePay = true // 是否使用iframe调用平安收银台
export const CacheSelectServiceChargeOrderInfoKey = 'CacheSelectServiceChargeOrderInfoKey'
